import { render, staticRenderFns } from "./SchoolAndSchdule.vue?vue&type=template&id=61ef609e&scoped=true&"
import script from "./SchoolAndSchdule.vue?vue&type=script&lang=js&"
export * from "./SchoolAndSchdule.vue?vue&type=script&lang=js&"
import style0 from "./SchoolAndSchdule.vue?vue&type=style&index=0&id=61ef609e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ef609e",
  null
  
)

export default component.exports